import { type ParsedClaims } from '../context/claims';
import { env } from './env';
import { getParameterByName } from './util';
import { type DeviceAdapter } from '../../platform/device/DeviceAdapter';

export interface FancyDeeplinkContext {
  hasAttemptedRedirect: boolean;
  mixpanelEnabled: boolean;
}

export function calculateShouldTryFancyDeeplink(
  claims: ParsedClaims | null,
  ctx: FancyDeeplinkContext,
  device: DeviceAdapter
): boolean {
  const shouldTryFancyDeeplinkParam = getParameterByName('shouldTryFancyDeeplink');

  if (!device.isMobile) {
    return false;
  }

  if (claims?.blockPhoneNumberInput) {
    return true;
  }

  if (device.isWebView) {
    return false;
  }

  if (ctx.hasAttemptedRedirect) {
    return false;
  }

  if (!env.PROD) {
    return true;
  }

  if (claims?.shouldTryFancyDeeplink) {
    return true;
  }

  if (shouldTryFancyDeeplinkParam === 'true') {
    return true;
  }

  if (!ctx.mixpanelEnabled) {
    return false;
  }

  return Math.random() < env.VITE_FEATURE_SKIPPY_SAMPLE_RATE;
}
